import React from "react";
import { Link } from "react-router-dom";
import { FaLinkedin, FaEnvelope } from "react-icons/fa";
import profilePicture from "../assets/profile.jpg";
import background from "../assets/background.jpg";

const Home = () => {
  const currentYear = new Date().getFullYear();

  return (
    <div
      className="relative w-full min-h-screen bg-cover bg-center flex flex-col items-center"
      style={{
        backgroundImage: `url(${background})`,
        backgroundAttachment: "fixed",
        backgroundSize: "cover",
      }}
    >
      <div className="absolute inset-0 bg-black bg-opacity-40"></div>

      {/* Header */}
      <header className="relative pt-20 flex flex-col items-center z-10 px-4">
        <div className="flex items-center space-x-4">
          <img
            src={profilePicture}
            alt="Profile"
            className="w-16 h-16 rounded-full border-4 border-white shadow-lg object-cover"
          />
          <h1 className="text-3xl font-bold text-white drop-shadow-md">
            Tinotenda Derek Mhlanga's Portfolio
          </h1>
        </div>
      </header>

      {/* Main Content */}
      <main className="relative z-10 w-full max-w-3xl px-4 mt-12 mb-12 flex flex-col items-center space-y-8">
        <div className="flex flex-col md:flex-row items-center md:space-x-4 space-y-4 md:space-y-0 w-full">
          <Link
            to="/experience"
            className="flex-1 py-3 px-6 text-center rounded-lg shadow font-medium text-white bg-blue-600 hover:bg-blue-700 transition transform hover:scale-105"
          >
            Work Experience
          </Link>
          <Link
            to="/education"
            className="flex-1 py-3 px-6 text-center rounded-lg shadow font-medium text-white bg-green-600 hover:bg-green-700 transition transform hover:scale-105"
          >
            Education
          </Link>
          <Link
            to="/diplomas"
            className="flex-1 py-3 px-6 rounded-lg text-center shadow font-medium text-white bg-purple-600 hover:bg-purple-700 transition transform hover:scale-105"
          >
            Diplomas/Certifications
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 w-full mt-4">
          <Link
            to="/genai-projects"
            className="py-3 px-6 text-center rounded-lg shadow font-medium text-white bg-gray-700 hover:bg-gray-800 transition transform hover:scale-105"
          >
            GenAI Projects
          </Link>
          <Link
            to="/deeplearning-projects"
            className="py-3 px-6 text-center rounded-lg shadow font-medium text-white bg-gray-700 hover:bg-gray-800 transition transform hover:scale-105"
          >
            Deep Learning Projects
          </Link>
          <Link
            to="/machinelearning-projects"
            className="py-3 px-6 text-center rounded-lg shadow font-medium text-white bg-gray-700 hover:bg-gray-800 transition transform hover:scale-105"
          >
            Machine Learning Projects
          </Link>
          <Link
            to="/mlops-projects"
            className="py-3 px-6 text-center rounded-lg shadow font-medium text-white bg-gray-700 hover:bg-gray-800 transition transform hover:scale-105"
          >
            MLOps Projects
          </Link>
          <Link
            to="/numerical-projects"
            className="py-3 px-6 text-center rounded-lg shadow font-medium text-white bg-gray-700 hover:bg-gray-800 transition transform hover:scale-105"
          >
            Numerical Analysis Projects In Python
          </Link>
        </div>
      </main>

      {/* Footer */}
      <footer className="relative z-10 mb-8 text-white text-center">
        <div className="flex items-center justify-center space-x-8 mb-4">
          <a
            href="mailto:mhlangatinotenda@gmail.com"
            className="flex items-center space-x-2 hover:text-gray-300 transition"
          >
            <FaEnvelope className="text-xl" />
            <span>Email</span>
          </a>
          <a
            href="https://www.linkedin.com/in/tinotenda-derek-mhlanga/"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center space-x-2 hover:text-gray-300 transition"
          >
            <FaLinkedin className="text-xl" />
            <span>LinkedIn</span>
          </a>
        </div>
        <p className="text-sm text-gray-200">
          &copy; {currentYear} Tinotenda Derek Mhlanga. All rights reserved.
        </p>
      </footer>
    </div>
  );
};

export default Home;
